<template>
  <el-form style="width: 100%" label-width="80px" label-position="left" :model="detail">
    <el-form-item label="投标价格" required class="flexItem">
      <el-input v-model="detail.Price" clearable>
        <span slot="prepend">￥</span>
        <el-switch slot="append" v-model="detail.Confirm" active-text="确认报价" />
      </el-input>
    </el-form-item>
    <el-form-item label="报价文件">
      <uploader :objectId="detail.Id" mode="offerfile" :autoupload="true" listtype="text" accept=".xls,.xlsx,.rar,.zip" />
    </el-form-item>
    <el-form-item label="投标备注">
      <el-input type="textarea" rows="3" v-model="detail.Remarks" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-position" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    uploader: () => import('@/views/system/file/multipleUpload.vue')
  },
  data () {
    return {
      detail: this.row
    }
  },
  props: {
    row: { type: Object },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  methods: {
    onSubmit () {
      this.$apis.project.inquiry.quote(this.detail).then(() => {
        typeof this.callback == "function" && this.callback(this.detail)
        this.$message({ message: "操作成功", type: "success" })
        this.$layer.close(this.layerid)
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
